import { doPolling } from '@ilyagershman/easy-poll';

interface Response {
  data: string | null;
  error: { code: number; message: string } | null;
}

export const useOrderListener = async (transactionId: string, offer: any): Promise<Response> => {
  const { access_token } = useAuth();
  let offerPayload = {} as { offers?: string };
  if (offer.offer_code !== null) {
    offerPayload.offers = encode(JSON.stringify(offer.offer_code))
  }

  try {
    const apiResult: any = await doPolling(
      () => $apiServer('/orders/verify', {
        method: 'post',
        query: { transaction_id: transactionId },
        body: offerPayload,
        headers: { Authorization: `Bearer ${access_token}` }
      }),
      {
        maxPolls: 15,
        maxErrors: 10,
        interval: 2000,
        until: (result: any) => result?.data?.data?.message?.toLowerCase() === 'success'
      }
    ).init();

    if (apiResult && apiResult.data?.data?.message?.toLowerCase() === 'success') {
      return { data: 'success', error: null };
    } else {
      throw new Error('Order confirmation failure')
    }
  } catch (error: any) {
    console.error('Error in useOrderListener:', error.message);
    return { data: null, error: { code: 500, message: error.message } };
  }
};
